import {atomWithStorage} from "jotai/utils";

const LOCAL_STORAGE_ADMIN_USERS_TABLE_COLUMNS_VISIBILITY_KEY = "adminUsersTableColumnsVisibility";
const LOCAL_STORAGE_ADMIN_USERS_TABLE_COLUMNS_SIZE_KEY = "adminUsersTableColumnsSize";

const DEFAULT_ADMIN_USERS_TABLE_COLUMN_VISIBILITY: Record<string, boolean> = {
    name: true,
    id: true,
    email: true,
    company: true,
    role: true,
    country: true,
    phone: true,
    isApiEnabled: true,
    createdAt: true,
    updatedAt: false,
};

export const adminUsersTableColumnsVisibilityAtom = atomWithStorage<Record<string, boolean>>(
    LOCAL_STORAGE_ADMIN_USERS_TABLE_COLUMNS_VISIBILITY_KEY,
    DEFAULT_ADMIN_USERS_TABLE_COLUMN_VISIBILITY,
);

export const adminUsersTableColumnsSizeAtom = atomWithStorage<Record<string, number> | undefined>(
    LOCAL_STORAGE_ADMIN_USERS_TABLE_COLUMNS_SIZE_KEY,
    undefined,
);
